import { Link } from 'react-router';
import { Money } from '../../../ui';
import { dayHeading } from '../../spending/format';
import { useToday } from '../../spending/hooks';
import { copy } from '../copy';
import { useTrips } from '../hooks';
import { FOCUS } from '../styles';

/** The most recent trip: total, day and store. */
export function LastTripTile() {
  const trips = useTrips();
  const today = useToday();
  const last = trips?.[0];
  if (!last) {
    return (
      <Link
        to="/m/shopping/trips"
        className={`inline-flex min-h-11 items-center text-sm text-muted ${FOCUS}`}
      >
        {copy.noTrips}
      </Link>
    );
  }
  return (
    <Link to={`/m/shopping/trips/${last.id}`} className={`flex flex-col gap-1 rounded-xl ${FOCUS}`}>
      <span className="text-sm text-muted">
        {dayHeading(last.date, today)}
        {last.store ? ` · ${last.store}` : ''}
      </span>
      <Money minor={last.totalMinor} cents="auto" className="block text-[28px] leading-tight" />
    </Link>
  );
}
